import { render, staticRenderFns } from "./AddElement.vue?vue&type=template&id=03e79e8b&scoped=true&"
import script from "./AddElement.vue?vue&type=script&lang=ts&"
export * from "./AddElement.vue?vue&type=script&lang=ts&"
import style0 from "./AddElement.vue?vue&type=style&index=0&id=03e79e8b&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03e79e8b",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VTooltip } from 'vuetify/lib/components/VTooltip';
installComponents(component, {VBtn,VIcon,VTooltip})
